<template>
	<button
		:class="buttonClasses"
		type="button"
		@click="onClick"
		:disabled="disabled"
	>
		<span class="teaming-toolbar-button__contentContainer">
			<slot name="leftIcon">
				<FontAwesomeIcon
					v-if="leftIcon"
					class="teaming-toolbar-button__icon"
					:icon="leftIcon"
				/>
			</slot>
			<slot></slot>
		</span>
	</button>
</template>

<script>
export default {
	name: "TeamingToolbarButton",
	events: [ "buttonPress", ],
	props: {
		leftIcon: {
			type: Array,
			default: () => undefined,
		},
		active: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		buttonClasses() {
			return {
				"teaming-toolbar-button": true,
				"teaming-toolbar-button--active": this.active === true,
				"teaming-toolbar-button--disabled": this.disabled === true,
			};
		},
	},
	methods: {
		onClick( e ) {
			this.$emit( "buttonPress", e );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-toolbar-button {
	border-radius: .25rem;
	cursor: pointer;
	outline: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	padding: .25rem .375rem .25rem .375rem;
	color: $teaming-toolbar-button-font-color--idle;
	background: $teaming-toolbar-button-background-color--idle;
	border: none;

	&:hover {
		color: $teaming-toolbar-button-font-color--hover;
		background: $teaming-toolbar-button-background-color--hover;
	}

	&:focus {
		color: $teaming-toolbar-button-font-color--active;
		background: $teaming-toolbar-button-background-color--active;
	}
}

.teaming-toolbar-button--active {
	color: $teaming-toolbar-button-font-color--active;
	background: $teaming-toolbar-button-background-color--active;
}

.teaming-toolbar-button--disabled {
	color: $teaming-toolbar-button-font-color--disabled;
	background: $teaming-toolbar-button-background-color--disabled;
	cursor: not-allowed;

	&:hover {
		color: $teaming-toolbar-button-font-color--disabled;
		background: $teaming-toolbar-button-background-color--disabled;
	}
}

.teaming-toolbar-button__contentContainer {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;

	height: 100%;
	width: 100%;
}
</style>
